import { Subscribe } from "@react-rxjs/core"
import { useTranslation } from "react-i18next"

import { AdaptiveLoader } from "@/components/AdaptiveLoader"
import { currentUser$, User as UserType, useUser } from "@/services/currentUser"

import { Button, LoadingButton } from "./ButtonComponents"

export const UserInner = ({ user }: { user: UserType }) => (
  <div className="relative">
    <Button
      className="flex h-[24px] cursor-pointer items-center justify-evenly rounded-none pl-[5px] text-(--button-primary-fg) grayscale hover:grayscale-0"
      type="button"
    >
      <img
        className="h-[24px] w-[24px]"
        src={user.avatar}
        alt={`${user.code}'s avatar`}
      />
      {user.code}
    </Button>
  </div>
)

const User = () => <UserInner user={useUser()} />

export const LoginControls = () => {
  const { t } = useTranslation()
  return (
    <Subscribe
      source$={currentUser$}
      fallback={
        <LoadingButton type="button">
          <AdaptiveLoader
            ariaLabel={t("loadingUserInformation")}
            size={18}
            color={"Colors/Foreground/fg-white"}
          />
        </LoadingButton>
      }
    >
      <User />
    </Subscribe>
  )
}
